/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import i18n from '@/i18n'
import { groupBy, sumBy } from 'lodash'
import dayjs from 'dayjs'
// import PaymentColors from '@/model/common/PaymentColors'

const entity = {
  updateTimestamp: {
    displayName: 'date'
  },
  payLogAmount: {
    displayName: 'totalAmount'
  },
  usageName: {
    displayName: 'purpose'
  },
  name: {
    displayName: 'detail',
    form: false
  },
  cashAccountNote: {
    displayName: 'note'
  },
  files: {
    displayName: 'file',
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}
const config = {
  load: async function (filter) {
    const [fromDate, toDate] = filter[0].dateFilter
    const res = (await hillo.get('Complex.php?op=getCashInOutDetailV3', {
      fromDate,
      toDate
    })).content.map(it => {
      if (!it.name) {
        if (it.payLogAmount >= 0) {
          it.name = i18n.t('Revenue')
        } else {
          it.name = i18n.t('Expenditure')
        }
      }
      it.displayDay = dayjs(it.updateTimestamp).format('YYYY-MM-DD')
      return it
    })
    const arrUmsatz = (res.filter(it => it.cashAccountNote.toLowerCase() === 'umsatz'))
    const arrTrinkgeld = (res.filter(it => it.cashAccountNote.toLowerCase() === 'trinkgeld'))
    const groupUmsatz = groupBy(arrUmsatz, 'displayDay')
    const groupTrinkgeld = groupBy(arrTrinkgeld, 'displayDay')
    const arrOther = res.filter(it => it.cashAccountNote.toLowerCase() !== 'umsatz' && it.cashAccountNote.toLowerCase() !== 'trinkgeld')
    const umsatzTotalList = groupUmsatz
      ? Object.entries(groupUmsatz).map(it => {
        return {
          updateTimestamp: it[0],
          displayDay: it[0],
          payLogAmount: sumBy(it[1], (o) => {
            return parseFloat(o.payLogAmount ? o.payLogAmount : 0)
          }).toFixed(2),
          name: 'umsatz',
          cashAccountNote: '',
          usageName: 'umsatz',
          typeCode: '',
          amountA: sumBy(it[1], (o) => {
            if (o.amountA) {
              return parseFloat(o.amountA)
            } else {
              return 0
            }
          }),
          amountB: sumBy(it[1], (o) => {
            if (o.amountB) {
              return parseFloat(o.amountB)
            } else {
              return 0
            }
          }),
          amountC: sumBy(it[1], (o) => {
            if (o.amountC) {
              return parseFloat(o.amountC)
            } else {
              return 0
            }
          })
        }
      })
      : []
    const trinkgeldTotalList = groupTrinkgeld
      ? Object.entries(groupTrinkgeld).map(it => {
        return {
          updateTimestamp: it[0],
          displayDay: it[0],
          payLogAmount: sumBy(it[1], (o) => {
            return parseFloat(o.payLogAmount)
          }).toFixed(2),
          name: 'Trinkgeld',
          cashAccountNote: '',
          usageName: 'Trinkgeld',
          typeCode: ''
        }
      })
      : []
    const currentList = umsatzTotalList.concat(trinkgeldTotalList.concat(arrOther)).sort((a, b) => new Date(b.displayDay) - new Date(a.displayDay))
    return currentList
  },
  add: async function (item) {
    return (await hillo.postWithUploadFile('Complex.php?op=manageCashAccount', { ...item }))
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getLatestTaxRateNames () {
  return (await hillo.get('Complex.php?op=getLatestTaxRateNames', {})).content
}

export async function getFastCCashAmountUntilDateTime (date) {
  return (await hillo.get('Complex.php?op=getFastCashAmountUntilDateTime', {
    dateTime: date
  }))?.content?.currentCashAmount ?? 0
}

export async function uploadCashBookFiles (orderId, file) {
  return await hillo.postWithUploadFile('Complex.php?op=changeCashAccountNoteFile', {
    orderId,
    file
  })
}
